// === INBOEDEL — "Inboedeldekking" section visibility ===
// The block holds the inboedelwaarde, its vaststelling, the gezinssamenstelling and (for vaste
// taxatie) the taxatie fields. When Infofolio supplied value + vaststelling and the
// gezinssamenstelling came from an earlier product, nothing in it needs the customer, so it is
// hidden. A missing or invalid value keeps it on screen: an error must stay reachable.

/** Fields rendered inside the section; an error on any of them keeps the section visible.
 *  BA_HERBWRD is NOT one of them: its error renders on the Glas tile (coverages.ts). */
export const COVERAGE_SECTION_FIELDS = [
  'Contractdocument.PP.IP.IP_VERZSOM',
  'Contractdocument.PP.IB.IB_INBVST',
  'Contractdocument.PP.IP.IP_GSS',
  'Contractdocument.PP.BA.BA_EINDGTX',
  'Supportsection.Divers.TaxatieVRT',
] as const;

export interface CoverageSectionArgs {
  data: any;
  /** Infofolio-locked field ids (`inboedelwaarde`, `inbvst`, ...). */
  lockedFields: ReadonlySet<string>;
  isGezinsamenstellingLocked: boolean;
  errors: Record<string, unknown>;
}

export function shouldShowCoverageSection({ data, lockedFields, isGezinsamenstellingLocked, errors }: CoverageSectionArgs): boolean {
  const ip = data?.Contractdocument?.PP?.IP;
  const ib = data?.Contractdocument?.PP?.IB;

  if (!lockedFields.has('inboedelwaarde') || !lockedFields.has('inbvst')) return true;
  if (!(Number(ip?.IP_VERZSOM) > 0) || !ib?.IB_INBVST) return true;
  if (ib.IB_INBVST === 'V') return true;
  if (!isGezinsamenstellingLocked) return true;
  return COVERAGE_SECTION_FIELDS.some((field) => Boolean(errors[field]));
}
